import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { NgxGpAutocompleteDirective } from '@angular-magic/ngx-gp-autocomplete';
import { Observable } from 'rxjs/internal/Observable';
import { TreeError } from '@angular/compiler';

@Component({
  selector: 'app-store-form',
  templateUrl: './store-form.component.html',
  styleUrls: ['./store-form.component.scss'],
})
export class StoreFormComponent implements OnInit {
  editForm: any;
  storeForm: any = {};
  role: any = localStorage.getItem('role');
  storePosReasons: { drawerReasons?: string[]; returnReasons?: string[]; priceChangeReasons?: string[]; ageVerificationOverrideReasons?: string[] } = {};
  id: any;
  selectStatus: any;
  storesPage: number = 1;
  storesWord: string = '';

  get isGeneralAdmin(): boolean {
    return this.role === 'admin';
  }
  imageSrc: any;
  logoImg: any;
  image: any;
  imageFile: any;
  logoFile: any;
  updateLogo: any;
  updateImg: any;
  // location:any = {type:'Point'}
  data = [
    { name: 'Active', status: 1 },
    { name: 'Inactive', status: 2 },
  ];
  isVisible = [
    { name: 'True', value: true },
    { name: 'False', value: false },
  ];
  geoCheck = [
    { name: 'True', value: true },
    { name: 'False', value: false },
  ];
  @ViewChild('ngxPlaces') placesRef: any;

  constructor(
    private route: Router,
    public service: ApiService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private page: Location,
    private router: ActivatedRoute
  ) {
    this.router.params.subscribe((route) => {
      this.id = route['id'];
    });
  }

  public selectAddress(place: google.maps.places.PlaceResult) {
    if (place.formatted_address)
      this.storeForm.patchValue({ address: place.formatted_address });
    if (place.geometry?.location?.lat()) {
      this.storeForm.patchValue({ latitude: place.geometry?.location?.lat() });
    }
    if (place.geometry?.location?.lng()) {
      this.storeForm.patchValue({ longitude: place.geometry?.location?.lng() });
    }

    const lat = place.geometry?.location?.lat();
    const lng = place.geometry?.location?.lng();

    if (lat && lng) {
      this.getTimeZone(lat, lng)
        .then((timeZone) => {
          this.storeForm.patchValue({ timeZone });
        })
        .catch((error) => {
          console.error('Failed to fetch timezone:', error);
        });
    }
  }

  private async getTimeZone(lat: number, lng: number): Promise<string> {
    const timestamp = Math.floor(new Date().getTime() / 1000);
    const apiKey = environment.apiKey;
    const url = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${apiKey}`;

    const response = await fetch(url);
    const data = await response.json();

    if (data.status === 'OK') {
      return data.timeZoneId;
    } else {
      throw new Error(data.errorMessage || 'Unable to fetch timezone');
    }
  }
  ngOnInit() {
    this.storesPage = +this.router.snapshot.queryParamMap.get('storesPage')! || 1;
    this.storesWord = this.router.snapshot.queryParamMap.get('storesWord') || '';
    this.storeForm = new FormGroup({
      storeName: new FormControl('', Validators.required),
      internalBackendUrl: new FormControl('', Validators.required),
      internalBackendKey: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      latitude: new FormControl(''),
      longitude: new FormControl(''),
      status: new FormControl(),
      ageLimit: new FormControl(null, Validators.required),
      timeZone: new FormControl(),
      isAgeVerification: new FormControl(false),  // Default value for nb-toggle
      isDoorOpening: new FormControl(true),      
      isNfcReaderEnabled: new FormControl(true), // Default to enabled
      isEcommerceEnabled: new FormControl(false), // Default ecommerce disabled
      posEnabled: new FormControl(false), // Default POS disabled
      requireVeriffForNonDanish: new FormControl(false),
      commissionRate: new FormControl(5, [Validators.min(0), Validators.max(100)]),
      vivaMerchantId: new FormControl(''),
      logo: new FormControl('', Validators.required),
      image: new FormControl('', Validators.required),
      isVisible: new FormControl(),
      geofenceCheck: new FormControl(),
      PCname: new FormControl(''),
      EquipmentComment: new FormControl(''),
    });
    if (this.id) {
      this.getStoreById();
    }
  }

  imgFileSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.imageSrc = URL.createObjectURL(event.target.files[0]);
    }
  }

  updateImage(event: any, name: any) {
    let files = event.target.files[0];
    // console.log(files, "file")
    const reader = new FileReader();
    reader.onload = (e: any) => {
      if (name == 'Logo') {
        this.logoImg = e.target.result;
        this.logoFile = files;
      } else {
        this.imageSrc = e.target.result;
        this.imageFile = files;
      }
    };
    reader.readAsDataURL(files);
  }

  removeImage(name: any) {
    if (name == 'Logo') {
      this.logoImg = '';
      this.storeForm.patchValue({
        logo: '',
      });
    } else {
      this.imageSrc = '';
      this.storeForm.patchValue({
        image: '',
      });
    }
  }

  get buttonTitle() {
    return this.id ? 'Edit Store' : 'Add Store';
  }

  getStoreById() {
    this.spinner.show();
    this.service.getRequest(`${ApiUrl.storeById}${this.id}`).subscribe(
      (res: any) => {
        if (res.response?.data?.logoImageUrl == null) {
          this.logoImg = res.response?.data?.logoImageUrl;
        } else {
          this.logoImg = `${environment.imageUrl}${res.response?.data?.logoImageUrl}`;
        }
        if (res.response?.data?.imageUrl == null) {
          this.imageSrc = res.response?.data?.imageUrl;
        } else {
          this.imageSrc = `${environment.imageUrl}${res.response?.data?.imageUrl}`;
        }

        this.updateImg = res.response?.data?.imageUrl;
        this.updateLogo = res.response?.data?.logoImageUrl;

        this.storeForm.patchValue({
          storeName: res.response?.data?.storeName,
          internalBackendUrl: res.response?.data?.internalBackendUrl,
          internalBackendKey: res.response?.data?.internalBackendKey,
          address: res.response?.data?.address,
          latitude: res.response?.data?.location?.coordinates[1],
          longitude: res.response?.data?.location?.coordinates[0],
          status: res.response?.data?.status,
          ageLimit: res.response?.data?.ageLimit,
          isVisible: res.response?.data?.isVisible,
          timeZone: res.response?.data?.timeZone,
          geofenceCheck: res.response?.data?.geofenceCheck,
          isDoorOpening: res.response?.data?.isDoorOpening,
          isAgeVerification: res.response?.data?.isAgeVerification,
          isNfcReaderEnabled: res.response?.data?.isNfcReaderEnabled,
          isEcommerceEnabled: res.response?.data?.isEcommerceEnabled || false,
          posEnabled: res.response?.data?.posEnabled || false,
          requireVeriffForNonDanish: res.response?.data?.requireVeriffForNonDanish || false,
          commissionRate: res.response?.data?.commissionRate ?? 5,
          vivaMerchantId: res.response?.data?.vivaMerchantId || '',
          PCname: res.response?.data?.PCname,
          EquipmentComment: res.response?.data?.EquipmentComment
        });
        this.storePosReasons = res.response?.data?.posReasons || {};
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }

  onSubmit() {
    if (this.id) {
      this.spinner.show();
      // console.log("store form data.........", this.storeForm.value)
      var location = 'Point';
      var coordinates: any = `${this.storeForm.value.longitude},${this.storeForm.value.latitude}`;
      const formData = new FormData();
      formData.append('storeName', this.storeForm.get('storeName').value);
      formData.append(
        'internalBackendUrl',
        this.storeForm.get('internalBackendUrl').value
      );
      formData.append(
        'internalBackendKey',
        this.storeForm.get('internalBackendKey').value
      );
      formData.append('address', this.storeForm.get('address').value);
      formData.append('coordinates', coordinates);
      formData.append('timeZone', this.storeForm.get('timeZone').value);
      if (this.logoFile) {
        formData.append('logo', this.logoFile);
      } else {
        formData.append('logo', this.updateLogo);
      }
      if (this.imageFile) {
        formData.append('image', this.imageFile);
      } else {
        formData.append('image', this.updateImg);
      }

      formData.append('status', this.storeForm.get('status').value);
      formData.append('ageLimit', this.storeForm.get('ageLimit').value);
      formData.append('location[type]', location);
      formData.append('isVisible', this.storeForm.get('isVisible').value);
      formData.append(
        'geofenceCheck',
        this.storeForm.get('geofenceCheck').value
      );
      formData.append('isAgeVerification', this.storeForm.get('isAgeVerification').value);
      formData.append('isDoorOpening', this.storeForm.get('isDoorOpening').value);
      formData.append('isNfcReaderEnabled', this.storeForm.get('isNfcReaderEnabled').value);
      formData.append('isEcommerceEnabled', this.storeForm.get('isEcommerceEnabled').value);
      formData.append('posEnabled', this.storeForm.get('posEnabled').value);
      formData.append('requireVeriffForNonDanish', this.storeForm.get('requireVeriffForNonDanish').value);
      formData.append('PCname', this.storeForm.get('PCname').value);
      formData.append('EquipmentComment', this.storeForm.get('EquipmentComment').value);

      // Only general admins can set commission rate
      if (this.isGeneralAdmin && this.storeForm.get('commissionRate').value !== null) {
        formData.append('commissionRate', this.storeForm.get('commissionRate').value);
      }

      // Both admins can set merchant ID (always send, even empty, to allow clearing)
      formData.append('vivaMerchantId', this.storeForm.get('vivaMerchantId').value ?? '');

      this.service
        .putRequest(`${ApiUrl.storeUpdateById}/${this.id}`, formData)
        .subscribe(
          (res: any) => {
            this.toastr.success(res.response.message);
            if (this.role == 'manager') {
              // console.log(this.role)
              this.route.navigate(['/dashboard']);
            } else {
              this.route.navigate(['/stores'], {
                queryParams: {
                  page: this.storesPage > 1 ? this.storesPage : null,
                  word: this.storesWord || null,
                },
              });
            }
            this.spinner.hide();
          },
          (err) => {
            this.toastr.error(err.error?.response?.message);
            this.spinner.hide();
          }
        );
    } else {
      if (this.storeForm.valid) {
        this.spinner.show();
        var coordinates: any = `${this.storeForm.value.longitude},${this.storeForm.value.latitude}`;
        var location = 'Point';
        var formData = new FormData();
        formData.append('storeName', this.storeForm.get('storeName').value);
        formData.append(
          'internalBackendUrl',
          this.storeForm.get('internalBackendUrl').value
        );
        formData.append(
          'internalBackendKey',
          this.storeForm.get('internalBackendKey').value
        );
        formData.append('address', this.storeForm.get('address').value);
        formData.append('coordinates', coordinates);
        formData.append('timeZone', this.storeForm.get('timeZone').value);
        formData.append('status', this.storeForm.get('status').value);
        formData.append('ageLimit', this.storeForm.get('ageLimit').value);
        formData.append('logo', this.logoFile);
        formData.append('image', this.imageFile);
        formData.append('location[type]', location);
        formData.append('isVisible', this.storeForm.get('isVisible').value);
        formData.append(
          'geofenceCheck',
          this.storeForm.get('geofenceCheck').value
        );
        formData.append('isAgeVerification', this.storeForm.get('isAgeVerification').value);
        formData.append('isDoorOpening', this.storeForm.get('isDoorOpening').value);
        formData.append('isNfcReaderEnabled', this.storeForm.get('isNfcReaderEnabled').value);
        formData.append('isEcommerceEnabled', this.storeForm.get('isEcommerceEnabled').value);
        formData.append('posEnabled', this.storeForm.get('posEnabled').value);
        formData.append('requireVeriffForNonDanish', this.storeForm.get('requireVeriffForNonDanish').value);
        formData.append('PCname', this.storeForm.get('PCname').value);
        formData.append('EquipmentComment', this.storeForm.get('EquipmentComment').value);

        // Only general admins can set commission rate
        if (this.isGeneralAdmin) {
          formData.append('commissionRate', this.storeForm.get('commissionRate').value ?? 5);
        }

        // Both admins can set merchant ID (always send, even empty, to allow clearing)
        formData.append('vivaMerchantId', this.storeForm.get('vivaMerchantId').value ?? '');

        this.service.postRequest(ApiUrl.addStore, formData).subscribe(
          (res: any) => {
            // console.log(res, "res")
            this.toastr.success(res.response.message);
            this.route.navigate(['/stores']);
            this.spinner.hide();
          },
          (err) => {
            // this.toastr.error(err.error?.response?.message)
            this.spinner.hide();
          }
        );
      } else {
        this.toastr.error('Please fill all required fields');
        this.spinner.hide();
      }
    }
    // console.log(this.storeForm)
  }

  onAutocompleteSelected(event: any) {
    const formattedAddress = event.formatted_address;
    const latitude = event.geometry.location.lat();
    const longitude = event.geometry.location.lng();

    // console.log('Selected Place:', formattedAddress);
    // console.log('Latitude:', latitude);
    // console.log('Longitude:', longitude);

    this.storeForm.get('address').setValue(formattedAddress);
    this.storeForm.get('latitude').setValue(latitude);
    this.storeForm.get('longitude').setValue(longitude);
  }
  autocompleteOptions = {
    componentRestrictions: { country: 'us' },
    types: ['address'],
  };

  onBack() {
    this.page.back();
  }
}
